import { forwardRef } from 'react'

import { twMerge } from 'tailwind-merge'

import { Icon } from '../../../v2/Icons'
import { FieldContainer } from '../SharedComponents/FieldContainer/FieldContainer'

export const InputField = forwardRef(
	(
		{
			label,
			icon,
			customIcon,
			disabled,
			fieldMessage,
			feedbackType = 'default',
			className,
			containerProps,
			normalizer,
			onChange,
			'data-testid': dataTestId,
			...props
		},
		ref
	) => {
		const handleChange = (e) => {
			if (normalizer) {
				e.target.value = normalizer(e.target.value)
			}
			onChange?.(e)
		}

		const inputId = props?.id || props?.name

		return (
			<FieldContainer
				label={label}
				disabled={disabled}
				fieldMessage={fieldMessage}
				feedbackType={feedbackType}
				containerProps={containerProps}
				htmlFor={inputId}
				required={props?.required}
			>
				<div className='flex items-center justify-between gap-2'>
					<input
						type='text'
						{...props}
						id={inputId}
						ref={ref}
						disabled={disabled}
						onChange={handleChange}
						className={twMerge(
							'w-full bg-transparent !text-base !font-normal text-gray-700 outline-none placeholder:!text-base placeholder:text-gray-400 focus:outline-none',
							disabled && '!text-gray-400 placeholder:text-gray-300',
							className
						)}
						data-testid={dataTestId || props?.name || props?.id}
					/>
					{customIcon ??
						(icon && (
							<Icon
								name={icon}
								className={twMerge(
									'!fill-orange-600 !h-4 !min-h-4 !w-4 !min-w-4',
									disabled && '!fill-gray-400'
								)}
							/>
						))}
				</div>
			</FieldContainer>
		)
	}
)

InputField.displayName = 'InputField'
